import React from 'react';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import {
  Container,
  Button,
} from '../../../components';

import './style.scss';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
} from '../../../config/constants';

const ParagraphHero = ({ entity, ...props }) => {

  const heroImageMobile = entity.getIn(['field_media', 0, 'styles', 'hero_mobile']);
  const heroImage = entity.getIn(['field_media', 0, 'styles', 'hero']);
  const heroLink = entity.getIn(['field_link', 0, 'uri']);
  const heroLinkTitle = entity.getIn(['field_link', 0, 'title']);
  const heroTitle = entity.getIn(['field_title', 0, 'value']);
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <div id={paragraphKey} className="ParagraphHero">
      <Image
        className="ParagraphHero__background"
        lazyload={false}
        src={{
          [SCREEN_MOBILE]: heroImageMobile,
          [SCREEN_TABLET]: heroImage,
        }}
        includeWebP
      />
      {heroLink && (
        <Container className="ParagraphHero__container">
          <h1 className="BasicPageCampaign__title">{heroTitle}</h1>
          <Button primary withIcon buttonIcon href={heroLink}>{heroLinkTitle}</Button>
        </Container>
      )}
    </div>
  );
};

export default ParagraphHero;
